import { createContext, useContext, useState, useCallback } from "react";
import ConfirmModal from "@shared/ui/ConfirmModal/ConfirmModal";
import { useTranslation } from "react-i18next";

const ConfirmContext = createContext(null);

export const useConfirm = () => useContext(ConfirmContext);

export const ConfirmProvider = ({ children }) => {
  const { t } = useTranslation();
  const [state, setState] = useState(null);

  const confirm = useCallback((options) => {
    setState(options);
  }, []);

  const handleConfirm = useCallback(() => {
    state?.onConfirm?.();
    setState(null);
  }, [state]);

  const handleCancel = useCallback(() => setState(null), []);

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}

      {state && (
        <ConfirmModal
          title={state.title ?? t("form.confirmTitle")}
          message={state.message}
          confirmLabel={state.confirmLabel}
          confirmVariant={state.confirmVariant}
          cancelLabel={state.cancelLabel}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
    </ConfirmContext.Provider>
  );
};
